"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchPresenceData = void 0;
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var Pod_1 = require("../../../net/Pod");
var fetchPresenceData = function () { return (0, Pod_1.PodRequest)('fetch_register', 'reply_register'); };
exports.fetchPresenceData = fetchPresenceData;
